import React from 'react';

/**
 * MaskEditor — editor de múltiples máscaras de fecha separadas internamente por "|".
 * Muestra cada máscara como un chip removible y permite agregar nuevas.
 *
 * Extraído de DocumentSeriesAdmin.jsx (P3 #73).
 */
const MaskEditor = ({ value, onChange, disabled, compact }) => {
  const [inputValue, setInputValue] = React.useState('');

  const masks = value
    ? value.split('|').map(m => m.trim()).filter(Boolean)
    : [];

  const addMask = () => {
    const newMask = inputValue.trim();
    if (!newMask || masks.includes(newMask)) {
      setInputValue('');
      return;
    }
    onChange([...masks, newMask].join('|'));
    setInputValue('');
  };

  const removeMask = (index) => {
    const updated = masks.filter((_, i) => i !== index);
    onChange(updated.join('|'));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addMask();
    }
  };

  const chipStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    background: disabled ? '#f0f0f0' : '#e8f0fe',
    color: disabled ? '#aaa' : '#1a56db',
    borderRadius: 4,
    padding: '2px 7px',
    marginRight: 4,
    marginBottom: 4,
    fontSize: '12px',
    fontFamily: 'monospace',
  };

  const removeBtn = {
    background: 'none',
    border: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
    color: disabled ? '#ccc' : '#666',
    padding: 0,
    fontSize: '13px',
    lineHeight: 1,
    marginLeft: 2,
  };

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: masks.length ? 4 : 0 }}>
        {masks.map((m, i) => (
          <span key={i} style={chipStyle}>
            {m}
            <button style={removeBtn} onClick={() => !disabled && removeMask(i)} title="Quitar máscara">×</button>
          </span>
        ))}
      </div>
      {!disabled && (
        <div style={{ display: 'flex', gap: 4 }}>
          <input
            type="text"
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={addMask}
            placeholder={compact ? 'dd/MM/yyyy' : 'Ej: dd/MM/yyyy — Enter para agregar'}
            style={{
              flex: 1,
              padding: compact ? '4px 6px' : '6px 10px',
              border: '1px solid #ccc',
              borderRadius: 4,
              fontSize: '13px',
              fontFamily: 'monospace',
              minWidth: compact ? 90 : 160,
            }}
          />
          <button
            onClick={addMask}
            style={{
              padding: compact ? '4px 8px' : '6px 10px',
              background: '#00468B',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '13px',
            }}
          >+</button>
        </div>
      )}
      {!disabled && !compact && (
        <p style={{ margin: '3px 0 0', fontSize: '11px', color: '#888' }}>
          Ingresá cada máscara y presioná Enter o "+". El valor será válido si cumple al menos una.
        </p>
      )}
    </div>
  );
};

export default MaskEditor;
